import React from 'react';
import styles from './SignInModal.module.scss';
import DefaultModal from '../Modal/DefaultModal/DefaultModal';

type ISignInModal = {
  show: boolean;
  onButtonClick: () => void;
  onClose: () => void;
};

const SignInModal: React.FC<ISignInModal> = ({
  show,
  onButtonClick,
  onClose
}) => {
  return (
    <>
      <DefaultModal show={show} onClose={onClose}>
        <div className={styles['container']}>
          <button className={styles['button']} onClick={onButtonClick}>
            Sign In
          </button>
        </div>
      </DefaultModal>
    </>
  );
};

export default SignInModal;
